import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getImage } from '../data/images';
import { Reveal } from './Reveal';
export function WaterViewSection() {
  const {
    lang,
    t
  } = useLanguage();
  const patio = getImage('patioPond');
  if (!patio) return null;
  return <section className="w-full bg-white py-20 lg:py-28" data-id="element-438" data-mp="1tvg3zpk4hqez">
      <div className="mx-auto max-w-editorial px-5 lg:px-8" data-id="element-439" data-mp="1tuxye2bklzue">
        <Reveal data-id="element-440" data-mp="w8qy34mautnu">
          <div className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-441" data-mp="w98z0ejwpw23">
            <div className="lg:col-span-5" data-id="element-442" data-mp="116innrzh23ov">
              <p className="label-caps text-gold" data-id="element-443" data-mp="117akf64t27gq">{t('Outdoor Living', 'Vida al Aire Libre')}</p>
              <h2 className="mt-5 max-w-[18ch] font-display text-[32px] font-semibold uppercase leading-[1.03] text-midnight sm:text-[40px] lg:text-[48px]" data-id="element-444" data-mp="164twq0hy0a61">
                {t('Your Own Peaceful Water View', 'Tu Propia Vista Tranquila al Agua')}
              </h2>
            </div>
            <div className="lg:col-span-7" data-id="element-445" data-mp="2mj276wpfut1b">
              <div className="gold-rule mb-6 w-full" data-id="element-446" data-mp="2mm7uq7if5mux" />
              <p className="text-[15px] leading-relaxed text-ink/80 lg:text-base" data-id="element-447" data-mp="3n3uyfwm3s5t3">
                {t('The private patio opens directly to the pond behind the home — a quiet place for morning coffee, evening conversation and the calm of the water.', 'El patio privado se abre directamente al estanque detrás de la propiedad: un lugar tranquilo para el café de la mañana, la conversación al atardecer y la calma del agua.')}
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.06} data-id="element-448" data-mp="2uggw1izmyi1l">
          <figure className="mt-10 h-[280px] w-full overflow-hidden sm:h-[420px] lg:h-[600px]" data-id="element-449" data-mp="2ufpcj6jbcaro">
            <img src={patio.src} alt={lang === 'en' ? patio.altEn : patio.altEs} width={patio.width} height={patio.height} loading="lazy" decoding="async" className="h-full w-full object-cover" style={{
            objectPosition: patio.objectPosition
          }} data-id="element-450" data-mp="2qfom0nixw949" />
          </figure>
        </Reveal>
      </div>
    </section>;
}